<template>
    <div class="view-container">
        <modal
            :showDialog="activeModal === 'CONTACTS'"
            @close="closeModal"
            :title="
                activeObject != null
                    ? $t('Contact') + ' ' + activeObject.systemName
                    : $t('Contact')
            "
        >
            <contact-modal :systemObject="activeObject"></contact-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'GALLERY'"
            @close="closeModal"
            :title="
                activeObject != null
                    ? $t('Gallery') + activeObject.systemName
                    : $t('Gallery')
            "
        >
            <gallery-modal :systemObject="activeObject"></gallery-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'INFO'"
            @close="closeModal"
            :title="
                activeObject != null && activeObject.column != null
                    ? activeObject.column.headerText
                    : ''
            "
        >
            <system-alarms-details-modal
                :data="activeObject"
                :day="activeDay"
                :apiMethodName="'getSystemAlarmFromToday'"
                :value="activeValue"
            ></system-alarms-details-modal>
        </modal>
        <modal
            :showDialog="activeModal == 'SETTINGS'"
            @close="closeModal"
            :title="
                activeObject != null
                    ? $t('Settings') + activeObject.systemName
                    : ''
            "
        >
            <settings-modal :systemObject="activeObject"></settings-modal>
        </modal>
        <div id="tooltip_status" style="position: fixed; z-index: 1">
            <tooltip-system-status
                v-if="activeModal === 'STATUS'"
                v-click-outside="closeModal"
                :activeObject="activeObject"
                :activeDay="activeDay"
            />
        </div>
        <modal
            :showDialog="activeModal === 'CHARTS'"
            @close="closeModal"
            :title="
                activeObject != null
                    ? activeObject.systemName + ` ${$t('ALARMS')}`
                    : ''
            "
        >
            <graphs-modal :data="activeObject"></graphs-modal>
        </modal>
        <modal
            :showDialog="activeModal == 'REPORT'"
            @close="closeModal"
            :title="
                activeObject != null
                    ? `${$t('GenerateReport')} ` + activeObject.systemName
                    : ''
            "
        >
            <generate-report-modal
                @cancel="closeModal"
                :systemObject="activeObject"
            ></generate-report-modal>
        </modal>
        <modal
            :showDialog="activeModal == 'SELECTSYSTEM'"
            @close="closeModal"
            :title="''"
        >
            <div class="m-4">
                <div class="mb-3">
                    {{ $t("SelectSystem") }}
                </div>
                <div style="text-align: center">
                    <Button
                        :title="$t('Ok')"
                        buttonClass="save-button semi-bold"
                        style="width: 100px"
                        @onClick="closeModal"
                    ></Button>
                </div>
            </div>
        </modal>
        <modal
            :showDialog="activeModal === 'ADD'"
            @close="closeModal"
            :title="$t('ADD_SYSTEM')"
        >
            <system-modal
                @cancel="closeModal"
                @save="closeModal('getData')"
            ></system-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'EDIT'"
            @close="closeModal"
            :title="$t('EDIT_SYSTEM')"
        >
            <system-modal
                :systemObject="activeObject"
                @cancel="closeModal"
                @save="closeModal('getData')"
            ></system-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'CHECKUP'"
            @close="closeModal"
            :title="$t('CHECKUP')"
        >
            <checkup-modal
                :system="activeObject"
                @cancel="closeModal"
                @save="checkupSystemDone"
            ></checkup-modal>
        </modal>
        <systems-filter
            ref="systems_filter"
            @modeChanged="(mode) => getData(mode)"
        ></systems-filter>
        <div>
            <div class="max-grid grid-filters">
                <ejs-grid
                    ref="grid"
                    height="100%"
                    width="100%"
                    :toolbar="$store.getters.isAdmin ? toolbarAdmin : toolbar"
                    :toolbarClick="toolbarClick"
                    :selectionSettings="selectionOptions"
                    :allowTextWrap="true"
                    :textWrapSettings="wrapSettings"
                    :dataBound="dataBound"
                    :dataSource="systems"
                    :allowPaging="true"
                    :pageSettings="pageSettings"
                    :allowFiltering="true"
                    :filterSettings="filterOptions"
                    :allowSorting="true"
                    :allowMultiSorting="true"
                    :allowPdfExport="true"
                    :allowCsvExport="true"
                    :allowExcelExport="true"
                    :showBusyIndicator="true"
                    style="position: relative"
                    :excelExportComplete="exportComplete"
                    :pdfExportComplete="exportComplete"
                    :showColumnChooser="true"
                    :enablePersistence="false"
                    :headerCellInfo="headerCellInfoEvent"
                    :actionComplete="actionComplete"
                >
                    <e-columns>
                        <e-column
                            field="systemName"
                            :sortComparer="sortComparer"
                            :template="ClickableSystemNameTemplate"
                            :headerText="$t('SystemName')"
                            width="142px"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            :visible="!isMobile"
                            field="systemGroup"
                            :headerText="$t('Group')"
                            textAlign="Left"
                            width="142px"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            :visible="!isMobile"
                            field="country"
                            :headerText="$t('Country')"
                            textAlign="Left"
                            width="142px"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="systemStatus"
                            :headerText="$t('SystemStatusInfo')"
                            width="142px"
                            :template="StatusWithLastUpdateTemplate"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <!-- <e-column field="tasks" :headerText="$t('Tasks')" width="100px" :template="TasksTemplate" textAlign="Left" :customAttributes="customAttributes" :filter="filterCheckBox"></e-column> -->
                        <e-column
                            field="tasksLow"
                            :headerText="$t('Low')"
                            width="100px"
                            :template="TasksTemplate"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="tasksMid"
                            :headerText="$t('Mid')"
                            width="100px"
                            :template="TasksTemplate"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="tasksHigh"
                            :headerText="$t('High')"
                            width="100px"
                            :template="TasksTemplate"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="isNewFarmerProblem"
                            :headerText="$t('Problems')"
                            width="100px"
                            :template="NewProblemsTemplate"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="errorLogsChecked"
                            :headerText="$t('ErrorLogsTodayYesterday7Days')"
                            width="142px"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="weightErrorLogsChecked"
                            :headerText="
                                $t('WeightErrorLogsTodayYesterday7Days')
                            "
                            width="142px"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="ghostUnknownAnimals"
                            :headerText="$t('GhostUnknownAnimals')"
                            width="142px"
                            textAlign="Left"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="lastCheckup"
                            :headerText="$t('LastCheckup')"
                            width="142px"
                            type="date"
                            textAlign="Left"
                            :format="dateTimeFormatOptions"
                            :customAttributes="customAttributes"
                        ></e-column>
                        <e-column
                            field="statusTab"
                            :headerText="$t('Status')"
                            :template="TooltipStatusTemplate"
                            width="142px"
                            textAlign="Left"
                            :allowFiltering="false"
                            :customAttributes="customAttributes"
                            :filter="filterCheckBox"
                        ></e-column>
                        <e-column
                            field="alarmPriority1"
                            :headerText="$t('HighLevelAlarm')"
                            :template="StatusTemplate"
                            width="142px"
                            textAlign="Left"
                            :allowFiltering="false"
                            :customAttributes="customAttributes"
                        ></e-column>
                        <e-column
                            field="alarmPriority2"
                            :headerText="$t('MidLevelAlarm')"
                            :template="StatusTemplate"
                            width="142px"
                            textAlign="Left"
                            :allowFiltering="false"
                            :customAttributes="customAttributes"
                        ></e-column>
                        <e-column
                            field="alarmPriority3"
                            :headerText="$t('LowLevelAlarm')"
                            :template="StatusTemplate"
                            width="142px"
                            textAlign="Left"
                            :allowFiltering="false"
                            :customAttributes="customAttributes"
                        ></e-column>
                        <e-column
                            :showInColumnChooser="false"
                            :headerText="''"
                            :template="ButtonsTemplate"
                            :allowFiltering="false"
                            :allowSorting="false"
                            :customAttributes="customAttributes"
                            width="281px"
                        ></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import SystemStatus from "@/components/Systems/SystemStatus";
import {
    Sort,
    Page,
    Filter,
    Toolbar,
    Search,
    CommandColumn,
    PdfExport,
    ExcelExport,
    ColumnChooser,
} from "@syncfusion/ej2-vue-grids";
import {
    getSystemStatus,
    getSystemsFromMode,
    updateSystemCheckupDone,
} from "@api";
import Button from "@/components/Button";
import SystemEdit from "../components/Systems/SystemEdit.vue";
import DeleteConfirm from "../components/DeleteConfirm.vue";
import Modal from "../components/Modal.vue";
import { Tooltip } from "@syncfusion/ej2-popups";
import SystemAlarmsDetailsModal from "../components/Systems/SystemAlarmsDetailsModal.vue";
import GalleryModal from "../components/Systems/GalleryModal.vue";
import ContactModal from "../components/Systems/ContactModal.vue";
import SettingsModal from "../components/Systems/SettingsModal.vue";
import TooltipSystemStatus from "../components/Systems/TooltipSystemStatus.vue";
import GraphsModal from "../components/Systems/GraphsModal.vue";
import Datepicker from "../components/Datepicker.vue";
import TableButtons from "../components/Systems/TableButtons.vue";
import SystemsFilter from "../components/Systems/SystemsFilter.vue";
import ProbablyOverflowingTextCell from "../components/Systems/ProbablyOverflowingTextCell";
import GenerateReportModal from "../components/Systems/GenerateReportModal.vue";
import SystemModal from "../components/Systems/SystemModal.vue";
import StatusWithLastUpdateTooltipVue from "../components/Systems/StatusWithLastUpdateTooltip.vue";
import ClickableSystemName from "../components/Systems/ClickableSystemName.vue";
import CheckupModal from "../components/Systems/CheckupModal.vue";
import TasksInfoCell from "../components/Systems/TasksInfoCell.vue";
import NewProblemsCell from "../components/Systems/NewProblemsCell.vue";

import Vue from "vue";

var context = null;

export default {
    props: [],
    components: {
        Button,
        Modal,
        SystemEdit,
        DeleteConfirm,
        SystemStatus,
        SystemAlarmsDetailsModal,
        GalleryModal,
        ContactModal,
        SettingsModal,
        TooltipSystemStatus,
        GraphsModal,
        Datepicker,
        TableButtons,
        SystemsFilter,
        ProbablyOverflowingTextCell,
        GenerateReportModal,
        SystemModal,
        StatusWithLastUpdateTooltipVue,
        ClickableSystemName,
        CheckupModal,
    },
    provide: {
        grid: [
            Sort,
            Page,
            Filter,
            Toolbar,
            Search,
            CommandColumn,
            PdfExport,
            ExcelExport,
            ColumnChooser,
        ],
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
    data() {
        return {
            interval: null,
            last_mode: "Active",
            systems: [],
            activeModal: "NONE",
            activeObject: null,
            activeDay: null,
            activeValue: null,

            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                // { text: this.$t('Systems'), id: 'table-title'},
                {
                    text: this.$t("ClearFilter"),
                    id: "clear-filters",
                    prefixIcon: "e-cancel",
                    align: "Right",
                },
                {
                    text: this.$t("Excelexport"),
                    prefixIcon: "e-excelexport",
                    align: "Right",
                    id: "excel-export",
                },
                {
                    text: this.$t("Csvexport"),
                    prefixIcon: "e-csvexport",
                    align: "Right",
                    id: "csv-export",
                },
                {
                    text: this.$t("GenerateReport"),
                    tooltipText: this.$t("GenerateReport"),
                    prefixIcon: "e-excelexport",
                    align: "Right",
                    id: "generateReport",
                },
                "Search",
                "ColumnChooser",
            ],
            toolbarAdmin: [
                // { text: this.$t('Systems'), id: 'table-title'},
                {
                    text: this.$t("ClearFilter"),
                    tooltipText: this.$t("ClearFilter"),
                    id: "clear-filters",
                    prefixIcon: "e-cancel",
                    align: "Right",
                },
                {
                    text: this.$t("Excelexport"),
                    tooltipText: this.$t("Excelexport"),
                    prefixIcon: "e-excelexport",
                    align: "Right",
                    id: "excel-export",
                },
                {
                    text: this.$t("Csvexport"),
                    tooltipText: this.$t("Csvexport"),
                    prefixIcon: "e-csvexport",
                    align: "Right",
                    id: "csv-export",
                },
                {
                    text: this.$t("GenerateReport"),
                    tooltipText: this.$t("GenerateReport"),
                    prefixIcon: "e-excelexport",
                    align: "Right",
                    id: "generateReport",
                },
                {
                    text: this.$t("AddSystem"),
                    tooltipText: this.$t("AddSystem"),
                    prefixIcon: "e-add",
                    id: "addSystem",
                    align: "Right",
                },
                {
                    text: this.$t("EditSystem"),
                    tooltipText: this.$t("EditSystem"),
                    prefixIcon: "e-edit",
                    id: "editSystem",
                    align: "Right",
                },
                "Search",
                "ColumnChooser",
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu",
            },
            filterCheckBox: {
                type: "CheckBox",
                columns:
                    this.systemName != null
                        ? [
                              {
                                  field: "systemName",
                                  matchCase: false,
                                  operator: "equal",
                                  value: this.systemName,
                              },
                          ]
                        : null,
            },
            dateTimeFormatOptions: { format: "yyyy-MM-dd", type: "dateTime" },
            customAttributes: { class: "customcss" },
            ClickableSystemNameTemplate: function () {
                return {
                    template: {
                        extends: ClickableSystemName,
                    },
                };
            },
            ButtonsTemplate: function () {
                return {
                    template: {
                        extends: TableButtons,
                        propsData: {
                            show(data, mode) {
                                switch (mode) {
                                    case "GALLERY":
                                        context.showModal(data, "GALLERY");
                                        break;
                                    case "ALARMS":
                                        this.$router.push({
                                            name: "alarms",
                                            params: {
                                                systemName: data.systemName,
                                                systemId: data.id,
                                            },
                                        });
                                        break;
                                    case "SERVICES":
                                        this.$router.push({
                                            name: "systemVisits",
                                            params: {
                                                systemName: data.systemName,
                                                systemId: data.id,
                                            },
                                        });
                                        break;
                                    case "CONTACTS":
                                        context.activeModal = "CONTACTS";
                                        context.activeObject = data;
                                        break;
                                    case "DEVICES":
                                        this.$router.push({
                                            name: "settingsDevices",
                                            params: {
                                                systemId: data.id,
                                                systemName: data.systemName,
                                            },
                                        });
                                        break;
                                    case "SETTINGS":
                                        this.$router.push({
                                            name: "settingsGeneral",
                                            params: {
                                                systemName: data.systemName,
                                                systemId: data.id,
                                            },
                                        });
                                        break;
                                    case "CHARTS":
                                        context.showModal(data, "CHARTS");
                                        break;
                                    case "MESSAGES":
                                        this.$router.push({
                                            name: "systemTickets",
                                            params: {
                                                systemName: data.systemName,
                                                systemId: data.id,
                                            },
                                        });
                                        break;
                                    case "CHECKUP":
                                        context.checkupDone(
                                            data.id,
                                            data.systemName
                                        );
                                        break;
                                }
                            },
                        },
                    },
                };
            },
            StatusTemplate: function () {
                return {
                    template: {
                        extends: SystemStatus,
                        propsData: {
                            callback: (data, mode, day, value) => {
                                context.showModal(data, mode, day, value);
                            },
                        },
                    },
                };
            },
            TextTemplate: function () {
                return {
                    template: {
                        extends: ProbablyOverflowingTextCell,
                    },
                };
            },
            StatusWithLastUpdateTemplate: function () {
                return {
                    template: {
                        extends: StatusWithLastUpdateTooltipVue,
                    },
                };
            },
            TasksTemplate: function () {
                return {
                    template: {
                        extends: TasksInfoCell,
                    },
                };
            },
            NewProblemsTemplate: function () {
                return {
                    template: {
                        extends: NewProblemsCell,
                    },
                };
            },
            TooltipStatusTemplate: function () {
                return {
                    template: {
                        extends: SystemStatus,
                        propsData: {
                            callback: (data, mode, day, value, args) => {
                                context.showModal(
                                    data,
                                    "STATUS",
                                    day,
                                    value,
                                    args
                                );
                            },
                        },
                    },
                };
            },
        };
    },
    methods: {
        async getData(mode) {
            this.$store.dispatch("set_loading", true);
            let result = await getSystemsFromMode(
                mode != undefined && mode != null ? mode : "Active"
            );
            this.last_mode =
                mode != undefined && mode != null ? mode : "Active";
            this.systems = result;

            this.systems = this.systems.sort(this.sortSystemsByName);

            const currentDate = new Date();

            this.systems.forEach((s) => {
                if (s.lastUpdate == "0001-01-01T00:00:00") {
                    s.systemStatus = "No Monitoring";
                }

                if (
                    new Date(s.lastCheckup).toDateString() ==
                    currentDate.toDateString()
                ) {
                    s.checkupDone = true;
                } else {
                    s.checkupDone = false;
                }

                if (s.lastCheckup == "0001-01-01T00:00:00") {
                    s.lastCheckup = null;
                }

                if (
                    s.alarmsOffCrfi != "0001-01-01T00:00:00" ||
                    s.alarmsOffMonitoring != "0001-01-01T00:00:00"
                ) {
                    s.systemStatus = "Alarms Off";
                }

                s.errorLogsChecked =
                    s.errorLogsToday +
                    " / " +
                    s.errorLogsYesterday +
                    " / " +
                    s.errorLogs7Days;
                s.weightErrorLogsChecked =
                    s.weightErrorLogsToday +
                    " / " +
                    s.weightErrorLogsYesterday +
                    " / " +
                    s.weightErrorLogs7Days;
                s.ghostUnknownAnimals =
                    s.ghostAnimals + " / " + s.unknownAnimals;
            });

            this.$store.dispatch("set_loading", false);
        },
        async getSystemStatusBySystemId(id) {
            if (this.statusVisible == false) {
                let data = await getSystemStatus(id);
                this.systemStatus = data;
                this.statusVisible = true;
            }
        },
        sortSystemsByName(a, b) {
            return a.systemName.localeCompare(b.systemName, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        },
        sortComparer: function (reference, comparer) {
            return reference.localeCompare(comparer, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        },
        closeModal(mode) {
            this.activeModal = "NONE";
            this.activeObject = null;
            this.activeDay = null;
            this.activeValue = null;
            if (mode == "getData") this.getData(this.last_mode);
        },
        showModal(obj, mode, day, value, args) {
            this.activeObject = obj;
            this.activeDay = day;
            this.activeModal = mode;
            this.activeValue = value;
            if (args != null) {
                var posX =
                    args.clientX + 300 < window.innerWidth
                        ? args.clientX + "px"
                        : args.clientX - 280 + "px";
                var posY =
                    args.clientY + 230 < window.innerHeight
                        ? args.clientY + 20 + "px"
                        : args.clientY - 226 + "px";

                var modal = document.getElementById("tooltip_status");
                modal.style.top = posY;
                modal.style.left = posX;
            }
        },
        async checkupDone(systemId, systemName) {
            this.activeObject = {
                systemId,
                systemName,
            };

            this.activeModal = "CHECKUP";
        },
        async checkupSystemDone() {
            this.closeModal();
            this.getData();
        },
        dataBound: function () {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClick: async function (args) {
            switch (args.item.id) {
                case "addSystem":
                    this.activeModal = "ADD";
                    break;
                case "table-title":
                    this.getData();
                    break;
                case "pdf-export":
                    this.systems.forEach((item) => {
                        item.alarmPriority1.reverse();
                        item.alarmPriority2.reverse();
                        item.alarmPriority3.reverse();
                        item.statusTab.reverse();
                    });
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.systems.forEach((item) => {
                        item.alarmPriority1.reverse();
                        item.alarmPriority2.reverse();
                        item.alarmPriority3.reverse();
                        item.statusTab.reverse();
                    });
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.systems.forEach((item) => {
                        item.alarmPriority1.reverse();
                        item.alarmPriority2.reverse();
                        item.alarmPriority3.reverse();
                        item.statusTab.reverse();
                    });
                    this.$refs.grid.excelExport();
                    break;
                case "clear-filters":
                    this.$refs.grid.clearFiltering();
                    break;
                case "generateReport":
                    let selectedRows = this.$refs.grid.getSelectedRecords();
                    // console.log(selectedRows[0])

                    if (selectedRows.length > 0) {
                        this.activeModal = "REPORT";
                        this.activeObject = selectedRows[0];
                    } else {
                        this.activeModal = "SELECTSYSTEM";
                    }
                    break;
                case "editSystem":
                    let rows = this.$refs.grid.getSelectedRecords();
                    if (rows.length > 0) {
                        this.activeModal = "EDIT";
                        this.activeObject = rows[0];
                    } else {
                        this.activeModal = "SELECTSYSTEM";
                    }
                    break;
            }
        },
        exportComplete(args) {
            this.systems.forEach((item) => {
                item.alarmPriority1.reverse();
                item.alarmPriority2.reverse();
                item.alarmPriority3.reverse();
                item.statusTab.reverse();
            });
        },
        intervalMethod() {
            this.getData(this.last_mode);
            this.$refs.systems_filter.getData();
        },
        headerCellInfoEvent(args) {
            if (["Discontinued", ""].includes(args.cell.column.headerText)) {
                return;
            }

            let tooltips = {
                errorLogsChecked: this.$i18n.t(
                    "errorLogsTodayYesterday7DaysTT"
                ),
                weightErrorLogsChecked: this.$i18n.t(
                    "weightErrorLogsTodayYesterday7DaysTT"
                ),
                ghostUnknownAnimals: this.$i18n.t("ghostUnknownAnimalsTT"),
            };

            if (tooltips[args.cell.column.field] != undefined) {
                new Tooltip(
                    {
                        content: tooltips[args.cell.column.field],
                    },
                    args.node
                );
            } else {
                return;
            }
        },
        actionComplete(args) {
            if (args.requestType == "columnstate") {
                var columns = this.$refs.grid
                    .getColumns()
                    .filter((x) => x.field != null && x.visible)
                    .map((x) => x.field);
                this.$store.dispatch("change_systemTableShown", columns);
            } else if (args.requestType == "filtering") {
                console.dir(this.$refs.grid);
            }
        },
        formatTableColumns() {
            var storeColumns = [];
            try {
                var savedColumns = JSON.parse(
                    localStorage.getItem("systemTableShownColumns")
                );
                if (Array.isArray(savedColumns)) {
                    storeColumns = [...savedColumns];
                }
            } catch (ex) {
                localStorage.removeItem("systemTableShownColumns");
            }
            if (storeColumns.length != 0) {
                this.$refs.grid.showColumns(storeColumns, "field");
                var columnsToHide = this.$refs.grid
                    .getColumns()
                    .filter((x) => x.field != null)
                    .map((x) => x.field)
                    .filter((x) => !storeColumns.includes(x));
                this.$refs.grid.hideColumns(columnsToHide, "field");
            } else {
                storeColumns = this.$refs.grid
                    .getColumns()
                    .filter((x) => x.showInColumnChooser && x.field != null)
                    .map((x) => x.field);
                this.$store.dispatch("change_systemTableShown", storeColumns);
                this.$refs.grid.showColumns(storeColumns, "field");
            }
        },
    },
    mounted: async function () {
        context = this;

        this.watch = this.$store.watch(
            function (state) {
                state.filter;
            },
            async () => {
                await this.getData();
            },
            { deep: true }
        );
        await this.getData();
        this.interval = setInterval(() => this.intervalMethod(), 60000);

        Vue.nextTick(() => this.formatTableColumns());
    },
    destroyed() {
        clearInterval(this.interval);
    },
};
</script>

<style scoped>
.table {
    border-top: none;
    border-left: none;
    border-right: none;
}

.table tbody {
    border-left: 1px solid #a3d4e0;
    border-right: 1px solid #a3d4e0;
}
.e-grid .e-headercell.customcss {
    padding: 0 5px 0 5px;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
}

.e-grid .e-headercell .e-headercelldiv {
    padding-right: 5px;
}
.e-gridchkbox.customcss .e-checkbox-wrapper {
    vertical-align: middle;
}

.hovercontent {
    position: absolute;
    left: 50%;
    top: 135px;
    transform: translate(-50%, -50%);
    background-color: #285a72;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.errorcontent {
    position: absolute;
    left: 50%;
    top: 135px;
    transform: translate(-50%, -50%);
    background-color: #285a72;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.footer-font {
    color: white;
    font-size: 16px;
    margin-right: 30px;
    font-weight: bold;
}

.footer-font-error {
    color: white;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
}

.footer-font-header {
    color: white;
    font-size: 16px;
}

.status-box {
    z-index: 999;
}

.status-box:hover .statushover {
    display: block;
}
</style>

<style>
.button-template {
    cursor: pointer;
    margin: 0 5px 0 5px;
}

.tippy-tooltip.customTheme-theme {
    background-color: #346f8b;
}

.tippy-popper[x-placement^="left"]
    .tippy-tooltip.customTheme-theme
    .tippy-arrow {
    border-left: 8px solid #346f8b;
}
</style>



// WEBPACK FOOTER //
// src/views/Systems.vue